<template>
  <el-main class="container">
    <div>
      <!-- 操作栏 -->
      <Nav>
        <div slot="right">
          <el-button v-show="hasAuthority('addMenu')" @click="handleAddMenu" type="primary">新建菜单</el-button>
        </div>
      </Nav>
      <!-- 菜单表格 -->
      <div class="table-box">
        <Table
          border
          align="center"
          :column="tableInfo.column"
          :data="tableInfo.data"
          :header-row-style="{height: '100px'}"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          :row-style="{height: '100px'}"
          pagination
          background
          :paginationTop="'30px'"
          :paginationAlign="'center'"
          layout="prev, pager, next, sizes, jumper"
          :page-sizes="[5, 10, 20, 30]"
          :pager-count="5"
          :current-page.sync="body.pageIndex"
          :total="tableInfo.total"
          :page-size="body.pageSize"
          @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange"
        >
        </Table>
      </div>
    </div>
    <!-- 菜单弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      :show-close="false"
      :title="dialogTitle"
      width="30%"
      :visible.sync="dialogVisible"
    >
      <div class="form">
        <div class="row">
          <div class="title">菜单名称</div>
          <div class="input">
            <el-input placeholder="请输入菜单名称" v-model="menuBody.permissionName"></el-input>
          </div>
        </div>
        <div class="row">
          <div class="title">菜单url</div>
          <div class="input">
            <el-input placeholder="请输入菜单url" v-model="menuBody.url"></el-input>
          </div>
        </div>
        <div class="row">
          <div class="title">菜单等级</div>
          <div class="select">
            <el-select v-model="menuLevel" placeholder="请选择菜单等级">
              <el-option
                v-for="item in menuLeveList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="title">一级菜单</div>
          <div class="select">
            <el-select v-model="gradeOneVal" placeholder="请选择上级菜单">
              <el-option
                v-for="item in gradeOneList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="title">二级菜单</div>
          <div class="select">
            <el-select v-model="gradeTwoVal" placeholder="请选择上级菜单">
              <el-option
                v-for="item in gradeTwoList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="title">按钮标识</div>
          <div class="input">
            <el-input placeholder="按钮级别的标识码" v-model="menuBody.subName"></el-input>
          </div>
        </div>
      </div>
      <div class="btn-box">
        <el-button type="primary" @click="handleSubmit">确定</el-button>
        <el-button @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import {
  addMenu,
  setMenu,
  deleteMenu,
  getMenuNew,
  getPermissionsList
} from '@/api/authority'
export default {
  data(){
    return{
      dialogVisible: false,
      dialogTitle: '',
      body: {
        pageSize: 10,
        pageIndex: 1,
        grade: null,
        word: ''
      },
      tableInfo: {
        total: 0,
        data: [],
        column: [
          {
            prop: 'name',
            label: '菜单名称'
          },
          {
            prop: 'url',
            label: '菜单url'
          },
          {
            prop: 'grade',
            label: '菜单等级'
          },
          {
            prop: 'fatherName',
            label: '上级菜单'
          },
          {
            label: '操作',
            render:(h, { row }) =>{
              return(
                <div>
                  <el-link v-show={this.hasAuthority('editMenu')} underline={false} type='primary' onClick={() => { this.handleSet(row) }}>编辑</el-link>&nbsp;&nbsp;
                  <el-link v-show={this.hasAuthority('editMenu')} underline={false} type='primary' onClick={() => { this.handleDelete(row) }}>删除</el-link>
                </div>
              )
            }
          },
        ]
      },
      menuLeveList: [
        {
          value: 1,
          label: '1级'
        },
        {
          value: 2,
          label: '2级'
        },
        {
          value: 3,
          label: '3级'
        }
      ],
      menuLevel: null,
      gradeOneList: [],
      gradeOneVal: '',
      gradeTwoList: [],
      gradeTwoVal: '',
      menuBody: {
        grade: '',
        originUuid: '',
        permissionName: '',
        subName: '',
        url: ''
      },
      //编辑参数
      setMenuBody: {
        permissionName: '',
        subName: '',
        url: '',
        uuid: ''
      },
      permissionsList: [],//权限列表
    }
  },
  created(){
    this.init();
  },
  methods: {
    async init(){
      await this.network().getMenuNew()
      await this.network().getPermissionsList()
    },
    network(){
      return {
        getMenuNew: async()=>{
          let { data } = await getMenuNew(this.body)
          this.tableInfo.data = data.list
          this.tableInfo.total = data.total
        },
        getPermissionsList: async()=>{
          let { data } = await getPermissionsList()
          // 临时处理方法 TODO
          this.filterList(data.list)
        },
        addMenu: async()=>{
          await addMenu(this.menuBody)
          this.$message.success('添加成功')
          this.handleClose()
          this.body.pageIndex = 1
          this.init()
        },
        deleteMenu: async(uuid)=>{
          await deleteMenu(uuid)
          this.$message.success('删除成功')
          this.init()
        },
        setMenu: async () => {
          //设置参数
          this.setMenuBody.permissionName = this.menuBody.permissionName
          this.setMenuBody.subName = this.menuBody.subName
          this.setMenuBody.url = this.menuBody.url
          await setMenu(this.setMenuBody)
          this.$message.success('修改成功')
          this.handleClose()
          this.init()
        }
      }
    },
    filterList(data){
      this.gradeOneList = []
      this.gradeTwoList = []
      this.permissionsList = data
      this.permissionsList.forEach(item=>{
        if(item.grade === 1){
          this.gradeOneList.push({
            label: item.name,
            value: item.uuid
          })
        }
        if(item.children.length > 0){
          item.children.forEach(item => {
            if(item.subName === ''){
              this.gradeTwoList.push({
                label: item.name,
                value: item.uuid
              })
            }
          })
        }
      })
    },
    handleAddMenu(){
      this.dialogTitle = '添加菜单'
      this.dialogVisible = true
    },
    checkForm(){
      if(this.menuBody.permissionName === ''){
        this.$message.error('请输入菜单名称')
        return false
      } else if(this.menuBody.url === ''){
        this.$message.error('请输入菜单url')
        return false
      } else if(this.menuBody.grade === ''){
        this.$message.error('请选择菜单等级')
        return false
      }
      return true
    },
    handleSubmit(){
      this.menuBody.grade = this.menuLevel
      this.gradeOneVal !== '' ? this.menuBody.originUuid = this.gradeOneVal : ''
      this.gradeTwoVal !== '' ? this.menuBody.originUuid = this.gradeTwoVal : ''
      if(this.checkForm()){
        this.dialogTitle === '添加菜单' ? this.network().addMenu() : this.network().setMenu()
      }
    },
    handleClose(){
      this.dialogVisible = false

      this.menuLevel = null
      this.gradeOneVal = ''
      this.gradeTwoVal = ''

      this.menuBody.permissionName = ''
      this.menuBody.url = ''
      this.menuBody.subName = ''
      this.menuBody.originUuid = ''
      this.menuBody.grade = null
    },
    handleSet(row){

      this.dialogTitle = '编辑菜单'
      this.menuBody.grade = row.grade

      row.onwPermissionUuid !== '' ? this.menuBody.originUuid = row.onwPermissionUuid : ''
      row.twoPermissionUuid !== '' ? this.menuBody.originUuid = row.twoPermissionUuid : ''

      this.menuBody.permissionName = row.name
      this.menuBody.subName = row.subName
      this.menuBody.url = row.url

      this.menuLevel = row.grade
      this.gradeOneVal = row.onwPermissionUuid
      this.gradeTwoVal = row.twoPermissionUuid

      this.setMenuBody.uuid = row.uuid

      this.dialogVisible = true
    },
    handleDelete(row){
      this.$confirm('是否删除该菜单？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.network().deleteMenu(row.uuid)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleSizeChange(size){
      this.body.pageSize = size
      this.body.pageIndex = 1
      this.network().getMenuNew()
    },
    handleCurrentChange(current){
      this.body.pageIndex = current
      this.network().getMenuNew()
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog{
  border-radius: 15px;
}
  .form{
    height: 400px;
    .row{
      display: flex;
      align-items: center;
      margin: 30px 0;
      .title{
        width: 100px;
        white-space: nowrap;
      }
      .input{
        width: 400px;
      }
      .select{
        width: 400px;
        /deep/.el-select{
          width: 100%;
        }
      }
    }
  }
  .btn-box{
    display: flex;
    justify-content: center;
  }
</style>
